<script setup>

defineProps({
  modelValue: Boolean,
  qrUrl: String,
  loading: Boolean,
  agentName: String,
  authCode: String
})

defineEmits(['update:modelValue'])

</script>

<template>
  <q-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <q-card style="width: 320px">
      <q-card-section class="text-h6 text-weight-bold text-center">
        {{ $t('agents.codeHelperText') }}
      </q-card-section>

      <q-card-section class="text-subtitle2 text-grey-7 q-pt-none text-center">
        {{ agentName }}
      </q-card-section>

      <q-card-section class="flex flex-center">
        <q-spinner
          v-if="loading"
          color="primary"
          size="2em"
        />

        <div
          v-else
          class="column items-center full-width"
        >
          <div class="text-h5 q-mb-md">
            {{ authCode }}
          </div>
        </div>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          v-close-popup
          flat
          color="grey-8"
          :label="$t('common.close')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

